import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

/**
 * «سرمایهٔ شما در صندوق‌ها» — what the logged-in member owns, across every
 * fund. Cross-fund for the same reason as `my-guarantees`: how much money a
 * person has in قرض‌الحسنه funds is a fact about the person.
 */
export const getMyDeposits = async () => {
    const { data }: { data: IMyDeposits } = await request.get(
        '/api/v1/moneypools/my-deposits/'
    )
    return data
}

/** queryKey: ['withdrawal-requests', moneypoolId] */
export const getWithdrawalRequests = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IWithdrawalRequestList } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/withdrawal-requests/`
    )
    return data
}

/** queryKey: ['withdrawal-request', moneypoolId, requestId] — carries `events` */
export const getWithdrawalRequest = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IWithdrawalRequest } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/withdrawal-requests/${ctx.queryKey[2]}/`
    )
    return data
}

export const createWithdrawalRequest = async (payload: {
    moneypoolId: string | number
    amount: number
    partial_accepted: boolean
    user_description?: string
    selected_card_number?: number | null
}) => {
    const { data }: { data: IWithdrawalRequest } = await request.post(
        `/api/v1/moneypools/${payload.moneypoolId}/withdrawal-requests/`,
        {
            amount: payload.amount,
            partial_accepted: payload.partial_accepted,
            user_description: payload.user_description ?? '',
            selected_card_number: payload.selected_card_number ?? null,
        }
    )
    return data
}

/**
 * Close a request. `received: true` = «پول را گرفتم» (completed),
 * `false` = «دیگر لازم ندارم» (canceled).
 *
 * Only the requester may call this — there is no manager equivalent anywhere
 * in the API. A manager can pay late or in pieces, but the claim is the
 * member's to end.
 */
export const closeWithdrawalRequest = async (payload: {
    moneypoolId: string | number
    requestId: string | number
    received: boolean
    note?: string
}) => {
    const { data }: { data: IWithdrawalRequest } = await request.patch(
        `/api/v1/moneypools/${payload.moneypoolId}/withdrawal-requests/${payload.requestId}/`,
        { received: payload.received, note: payload.note ?? '' }
    )
    return data
}

/** queryKey: ['admin-withdrawal-requests', moneypoolId, q] — manager only */
export const getWithdrawalCartable = async (ctx: QueryFunctionContext) => {
    const query = ctx.queryKey[2] ? `?q=${ctx.queryKey[2]}` : ''
    const { data }: { data: { results: Array<IWithdrawalCartableRow> } } =
        await request.get(
            `/api/v1/moneypools/${ctx.queryKey[1]}/admin-withdrawal-requests/${query}`
        )
    return data
}
